import type { CurrentUser } from '@td/shared';
import { Doodle, isDoodle, DEFAULT_AVATAR_MARK } from './Doodle';

/**
 * Whatever the teacher chose to have beside her name.
 *
 * Three answers, and all three are reasonable: a line drawing, a photograph
 * of herself, or nothing at all. The last one matters — an apple next to your
 * own name every day of the year is somebody else's idea of charming.
 *
 * One component so the sidebar and Settings cannot disagree about what the
 * setting means. The photo is fetched from an authenticated route like every
 * other image in the app; the version in the query string is what stops a new
 * one being served from the old cache entry.
 */
export function TeacherMark({
  user,
  size = 18,
  className = '',
}: {
  user: CurrentUser | null | undefined;
  size?: number;
  className?: string;
}) {
  const mark = user?.settings.avatarMark;

  if (mark === 'none') return null;

  if (mark === 'photo') {
    // The setting can outlive the photo — deleting it resets the choice, but
    // a stale tab may still be holding the old value.
    if (!user?.hasPhoto) return null;

    return (
      <img
        src={`/api/auth/photo?v=${user.photoVersion}`}
        alt=""
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className={`shrink-0 rounded-full border border-sand object-cover ${className}`}
      />
    );
  }

  return (
    <Doodle
      name={isDoodle(mark) ? mark : DEFAULT_AVATAR_MARK}
      size={size}
      className={`shrink-0 text-terracotta ${className}`}
    />
  );
}
